import { CheckOutlined, PlusOutlined } from "@ant-design/icons";
import { Table, Tag, Popconfirm, Button, Flex, message, Pagination, Input, Space } from "antd";
import { useState, useEffect } from "react";
import { createAISelector, deleteAISelector, fetchAICategories, fetchAISelectors, updateAISelector } from "../../api/ai";

const AIStockScreenerScreen = () => {
    const [stockCategoryId, setStockCategoryId] = useState('0');
    const [tabData, setTabData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    const tabCols = [
        {
            title: 'Filter',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            render: (text, record, index) => {
                if (record.isEditing) {
                    return <Input
                        allowClear
                        style={{ maxWidth: 200, fontSize: 12 }}
                        value={record.name}
                        placeholder="please input filter"
                        onChange={evt => onInputChange(record.id, null, evt.target.value, index, 'name')}
                    />;
                }
                return text;
            }
        },
        {
            title: 'Sub Filters',
            dataIndex: 'children',
            key: 'children',
            render: (text, record) => {
                return (
                    <Space wrap align="center" size={4}>
                        {
                            Array.from(text).filter(item => item.id !== '-1').map(item => {
                                return (
                                    record.isEditing ?
                                        <Space.Compact key={item.id}>
                                            <Input
                                                addonBefore='Name'
                                                style={{ maxWidth: 200, fontSize: 12 }}
                                                value={item.name}
                                                key={item.id}
                                                placeholder="please input filter"
                                                onChange={evt => onInputChange(record.id, item.id, evt.target.value, null, 'name')}
                                            />
                                            <Input
                                                allowClear
                                                addonBefore='Weight'
                                                style={{ maxWidth: 150, fontSize: 12 }}
                                                value={item.weight}
                                                type="number"
                                                placeholder="weight"
                                                onChange={evt => onInputChange(record.id, item.id, evt.target.value, null, 'weight')} />
                                        </Space.Compact>
                                        :
                                        <Tag
                                            key={item.id}
                                            style={{ cursor: 'pointer' }}
                                            color={record.selectedIds.includes(item.id) ? '#1677ff' : null}
                                            onClick={() => selectFilter(record.id, item.id)}>
                                            {item.name}&nbsp;<b>{item.weight}</b>&nbsp;
                                            {record.selectedIds.includes(item.id) ? <CheckOutlined /> : null}
                                        </Tag>
                                )
                            })
                        }
                        {
                            (record.isEditing && record.id !== '-1') ?
                                <>
                                    {
                                        Array.from(text).filter(item => item.id === '-1').map((item, index) => {
                                            return (
                                                <Space.Compact key={index}>
                                                    <Input
                                                        allowClear
                                                        addonBefore='Name'
                                                        style={{ maxWidth: 200, fontSize: 12 }}
                                                        value={item.name}
                                                        placeholder="sub filter name"
                                                        onChange={evt => onInputChange(record.id, '-1', evt.target.value, index, 'name')}
                                                    />
                                                    <Input
                                                        addonBefore='Weight'
                                                        style={{ maxWidth: 150, fontSize: 12 }}
                                                        value={item.weight}
                                                        type="number"
                                                        placeholder="weight"
                                                        onChange={evt => onInputChange(record.id, '-1', evt.target.value, index, 'weight')} />
                                                </Space.Compact>
                                            )
                                        })
                                    }
                                    <Button
                                        shape="circle"
                                        icon={<PlusOutlined style={{ fontSize: 12 }} />}
                                        onClick={() => addNewSubFilter(record.id)}
                                        size="small" />
                                </> : null
                        }
                    </Space>
                )
            }
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
            key: 'weight',
            width: 200,
            render: (text, record, index) => {
                if (record.isEditing) {
                    return <Input
                        style={{ maxWidth: 200, fontSize: 12 }}
                        value={record.weight}
                        placeholder="weight"
                        type="number"
                        onChange={evt => onInputChange(record.id, null, evt.target.value, index, 'weight')}
                    />;
                }
                return text;
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: 200,
            render: (text, record) => {
                return (
                    record.isEditing ?
                        <Button.Group size='small'>
                            <Button type='link' loading={record.isLoading} onClick={() => saveEdit(record)}>Save</Button>
                            <Button type='link' onClick={() => cancelEdit(record)}><label style={{ color: '#afafaf', cursor: 'pointer' }}>Cancel</label></Button>
                        </Button.Group>
                        :
                        <Button.Group size='small'>
                            <Button type='link' onClick={() => editFilter(record)}>Edit</Button>
                            {
                                record.selectedIds && record.selectedIds.length > 0
                                    ?
                                    <Popconfirm
                                        title="Delete"
                                        description="Are you sure to delete all these filters?"
                                        onConfirm={() => deleteFilter(record, record.selectedIds)}
                                        okText="Yes"
                                        cancelText="No" >
                                        <Button danger type='link' loading={record.isLoading}>Delete Items</Button>
                                    </Popconfirm>
                                    :
                                    <Popconfirm
                                        title="Delete"
                                        description="Are you sure to delete this filter?"
                                        onConfirm={() => deleteFilter(record, [record.id])}
                                        okText="Yes"
                                        cancelText="No" >
                                        <Button danger type='link' loading={record.isLoading}>Delete</Button>
                                    </Popconfirm>
                            }
                        </Button.Group>
                )
            }
        }
    ];

    useEffect(() => {
        fetchData(pageNum, pageSize);
        fetchAICategories({}).then(res => {
            if(res.list) {
                setStockCategoryId((res.list.find(item => item.name === 'stock screener'))?.id)
            }
        })
    }, [])

    const fetchData = (pNum, pSize) => {
        setLoading(true);
        let params = {
            'page.num': pNum,
            'page.size': pSize,
            'parentId': '0'
        };
        fetchAISelectors(params).then(res => {
            if (res.page) {
                setTotal(res.page.total);
            }
            if (res.list) {
                setTabData(res.list.map(item => {
                    return {
                        ...item, 
                        isEditing: false,
                        isLoading: false,
                        selectedIds: []
                    };
                }));
            }
        }).finally(() => setLoading(false))
    }

    const pageChange = (page, size) => {
        setPageNum(page);
        setPageSize(size);
        fetchData(page, size);
    }

    const editFilter = (item) => {
        item.isEditing = true;
        setTabData([...tabData]);
    }

    const deleteFilter = (category, ids) => {
        category.isLoading = true;
        setTabData([...tabData]);
        let reqArr = [];
        ids.forEach(item => {
            reqArr.push(deleteAISelector(item));
        })

        Promise.all(reqArr).then(res => {
            if(res.some(item => item)) {
                fetchData(pageNum, pageSize);
            }
        })
    }

    const onInputChange = (categoryId, subCategoryId, value, index, key) => {
        if (subCategoryId === null) {
            tabData[index][key] = value;
            setTabData([...tabData]);
        } else {
            let category = tabData.find(item => item.id === categoryId);
            if (!category) return;
            if (subCategoryId === '-1') {
                let newDatas = category.children.filter(item => item.id === '-1');
                if (newDatas[index]) newDatas[index][key] = value;
            } else {
                let subCategory = category.children.find(item => item.id === subCategoryId);
                if (subCategory) subCategory[key] = value
            }
            setTabData([...tabData]);
        }
    }

    const saveEdit = (item) => {
        let canSubmit = String(item.name).trim() && item.children.every(ch => String(ch.name).trim());
        if (!canSubmit) {
            message.warning('Filter name can not be empty!');
            return;
        }
        item.isLoading = true;
        setTabData([...tabData]);

        let newItem = { ...item };
        newItem.categoryId = stockCategoryId;
        if (newItem.id === '-1') delete newItem['id'];
        let children = Array.from(newItem['children'] ?? []).length > 0 ? [...newItem['children']] : [];
        delete newItem['children'];

        let reqArr = [];
        if (newItem.id) {
            reqArr.push(updateAISelector(newItem));
        } else {
            reqArr.push(createAISelector(newItem));
        }

        children = children.filter(item => item.name);
        children.forEach(item => {
            item.categoryId = stockCategoryId;
            if (item.id === '-1') {
                reqArr.push(createAISelector(item));
            } else {
                reqArr.push(updateAISelector(item));
            }
        });

        Promise.all(reqArr).then(res => {
            fetchData(pageNum, pageSize);
        }).finally(() => {
            setLoading(false);
        });
    }

    const cancelEdit = (item) => {
        item.isEditing = false;
        item.children = [...item.children].filter(ch => ch.id !== '-1');
        let newData = [...tabData].filter(cgr => cgr.id !== '-1');
        setTabData(newData);
    }

    const selectFilter = (categoryId, subCategoryId) => {
        let category = tabData.find(item => item.id === categoryId);
        if (!category) return;
        if (category.selectedIds.includes(subCategoryId)) {
            category.selectedIds = category.selectedIds.filter(item => item !== subCategoryId);
        } else {
            category.selectedIds.push(subCategoryId);
        }

        setTabData([...tabData]);
    }

    const addNewFilter = () => {
        setTabData([
            {
                name: '',
                level: 0,
                weight: 0,
                parentId: '0',
                children: [],
                id: '-1',
                isEditing: true,
            }, ...tabData
        ]);
    }

    const addNewSubFilter = (categoryId) => {
        let category = tabData.find(item => item.id === categoryId);
        if (!category) return;
        category.children = [...category.children].concat({ name: '', parentId: categoryId, id: '-1', weight: 0 });
        setTabData([...tabData]);
    }

    return (
        <div className='main-wrapper'>
            <div className='top-part cnt-item'>
                <Flex justify='space-between'>
                    <Button type='primary' icon={<PlusOutlined />} onClick={addNewFilter}>Create Filter</Button>
                </Flex>
            </div>
            <div className='cnt-item'>
                <Table
                    loading={loading}
                    rowKey={(record) => record.id}
                    rowClassName={'table-row'}
                    size='small'
                    dataSource={tabData}
                    columns={tabCols}
                    pagination={false}
                    expandable={{ rowExpandable: (record) => false, showExpandColumn: false }} />
            </div>
            <div className='footer-part cnt-item'>
                <Pagination
                    total={total}
                    showTotal={(total) => `total ${total}`}
                    current={pageNum}
                    pageSize={pageSize}
                    showSizeChanger={true}
                    pageSizeOptions={[10, 20, 30, 50]}
                    onChange={(page, size) => pageChange(page, size)}
                />
            </div>
        </div>
    )
}

export default AIStockScreenerScreen;